export default {"src":"/_next/static/media/link-icon-white.94fed35e.svg","height":14,"width":14};